import { render, staticRenderFns } from "./DeliveryUpdateForm.vue?vue&type=template&id=c6595b68&scoped=true"
import script from "./DeliveryUpdateForm.vue?vue&type=script&lang=js"
export * from "./DeliveryUpdateForm.vue?vue&type=script&lang=js"
import style0 from "./DeliveryUpdateForm.vue?vue&type=style&index=0&id=c6595b68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6595b68",
  null
  
)

export default component.exports